import "../assets/scss/styles.scss"

import React from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"

import { useIntl } from "gatsby-plugin-intl"

import Navbar from "../components/navbar/navbar"
import Footer from "../components/footer/footer"
import Overview from "../components/overview/overview"

export default function Index({ data }) {
  const intl = useIntl()
  const projects = data.allMarkdownRemark.edges

  projects.map((project) => {
    return project.node.frontmatter.slug_converted = project.node.frontmatter.lang + '/project/' + project.node.frontmatter.slug;
  });

  const filteredProjectsByLanguage = projects.filter(project => project.node.frontmatter.lang === intl.locale);

  return (
    <React.Fragment>
      <Helmet>
        <title>Engineering: people's work | Witteveen+Bos</title>
        <meta name={`robots`} content={`noindex, nofollow`} />
      </Helmet>
      <Navbar />
      <Overview data={filteredProjectsByLanguage} />
      <Footer />
    </React.Fragment>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: {frontmatter: {archive: {eq: false}}}) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            thumbnail {
              publicURL
            }
            type
            lang
            slug
          }
          excerpt
        }
      }
    }
  }
`
